const environment = require('./environment');
const argv = process ? require('minimist')(process.argv.slice(2)) : {};

const { ENVIRONMENT } = 'undefined' !== typeof window ? window.env : argv['ENVIRONMENT'] ? argv : process.env;

const buildConfig = environment[ENVIRONMENT || 'development'] || {};

const sentryURL = 'https://16a8291a236a41fe8f36d3fd90c09774@sentry.io/173759';

const sentryOptions = {
  // List of common ignore rules from https://docs.sentry.io/clients/javascript/tips/
  ignoreErrors: [
    /Blocked a frame with origin/,
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // happening only for old android devices (<= 4.4) so it's probably safe to ignore
    'INVALID_STATE_ERR: DOM Exception 11',
    // happening only for android 7.1.1, chrome mobile 45.0.2454
    'Cannot read property \'end\' of undefined',
    'Cannot read property \'DOMNodeInsertedByJs\' of undefined',
    'Cannot read property \'onWindowLoaded\' of undefined',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // failed to load favicon, url seems to be working, we can probably ignore this for now..
    'Failed to execute \'send\' on \'XMLHttpRequest\': Failed to load \'https://d1ngqubzx882dn.cloudfront.net/static/favicon.png\'.',
  ],
  whitelistUrls: [
    /d3pv2lg0hr7u1j.cloudfront.net/i,
    /d37jpvxvnmgnc2.cloudfront.net/i,
    /assets.healthunlocked.com/i,
    /assets.hu-production.be/i,
    /assets.hu-staging.be/i,
  ],
};

module.exports = Object.assign({
  API_PATH: 'https://healthunlocked.com/api/',
  SOLARIS_API_PATH: 'http://solaris.healthunlocked.com/',
  DISCOVER_API_PATH: 'http://discover-api.healthunlocked.com/',
  DISCOVER_API_KEY: '',

  // Run-time
  WS_URL: 'wss://health-unlocked.com/',
  WS_PATH: '/ws',

  USE_DEV_PROXY: false,

  isServer: typeof window === 'undefined',

  cdn: {
    img: buildConfig.IMG_PATH,
    static: `${buildConfig.IMG_PATH}/static/`,
    postImg: `${buildConfig.IMG_PATH}/post/post_/`,
    communityLogos: `${buildConfig.IMG_PATH}/group-logos/`,
    communityBanners: `${buildConfig.IMG_PATH}/group-banners/`,
    communityPromoImages: `${buildConfig.IMG_PATH}/group-campaigns/`,
    avatars: `${buildConfig.IMG_PATH}/avatars/`,
    userBanners: `${buildConfig.IMG_PATH}/user-banners/`,
    emoji: `${buildConfig.IMG_PATH}/betelgeuse/img/emoji/unicode/`,
    resources: `${buildConfig.IMG_PATH}/resources/`,
    navigator: `${buildConfig.IMG_PATH}/programs/`,
    programs: `${buildConfig.CDN_PATH}/solaris/programs/`,
    tags: `${buildConfig.CDN_PATH}/solaris/tags/`,
    articles: `${buildConfig.CDN_PATH}/solaris/articles/`,
    smiley: 'https://d37jpvxvnmgnc2.cloudfront.net/aurora/images/smiley/',
    bg: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/',
    resourcesIndex: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/index-pages/resources/',
    programsIndex: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/index-pages/programs/',
    localesPath: `${buildConfig.CDN_PATH}/static/locales/`,
  },

  defaultProfileImage: `${buildConfig.IMG_PATH}/avatars/avatar_hidden_medium_200x200.jpg`,
  defaultBannerImage: `${buildConfig.IMG_PATH}/betelgeuse/img/gallery/default-banner_1170x250.png`,

  avatars: {
    smallSuffix: '_small@2x_100x100.jpg',
    mediumSuffix: '_medium@2x_400x400.jpg',
  },

  groups: {
    bannerSuffix: '_1170x250.jpg',
    suffix: '_140x140.jpg',
    smallSuffix: '_50x50.jpg',
  },

  roles: {
    admin: 1,
    restricted: 30,
  },

  fb: {
    page: 'http://www.facebook.com/healthunlocked',
    appId: '542626299164413',
    scope: 'public_profile,email,user_birthday',
  },

  google: {
    clientId: '597276905358-r3l7ftfs10mu2jnttvme4pl3p2moaqq5.apps.googleusercontent.com',
  },

  authTypes: {
    facebook: 0,
    google: 1,
  },

  api: {
    communityTypes: {
      EDITORIAL: 8,
    },
    postTypes: {
      POST: 4,
      QUESTION: 1,
      POLL: 6,
      POLL_CHOICE: 7,
      ANSWER: 2,
      COMMENT: 19,
    },
  },

  community: {
    en: {
      support: 'http://support.healthunlocked.com/',
      blog: 'http://blog.healthunlocked.com/',
      fb: 'https://www.facebook.com/healthunlocked',
      twitter: 'https://twitter.com/healthunlocked',
      lockPost: 'http://support.healthunlocked.com/customer/portal/articles/2719984-turn-off-replying-on-posts-',
    },
    es: {
      support: 'http://ayuda.healthunlocked.com/',
      blog: 'http://bloges.healthunlocked.com/',
      fb: 'https://www.facebook.com/huespanol',
      twitter: 'https://twitter.com/huespanol',
      lockPost: 'http://support.healthunlocked.com/customer/es/portal/articles/2719984-turn-off-replying-on-posts-',
    },
    pt: {
      support: 'http://ajuda.healthunlocked.com/',
      blog: 'http://blogpt.healthunlocked.com/',
      fb: 'https://www.facebook.com/huportugues',
      twitter: 'https://twitter.com/huportugues',
      lockPost: 'http://support.healthunlocked.com/customer/pt/portal/articles/2719984-turn-off-replying-on-posts-',
    },
  },

  guides: {

    guideline: {
      en: 'http://support.healthunlocked.com/customer/portal/articles/1345307-community-guidelines',
      es: 'http://support.healthunlocked.com/customer/es/portal/articles/1345307-community-guidelines',
      pt: 'http://support.healthunlocked.com/customer/pt/portal/articles/1345307-community-guidelines',
    },

    founders: {
      en: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-en/founders-guideA.pdf',
      pt: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-pt/fundadores-guiaA.pdf',
      es: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-es/fundadores-guiaA.pdf',
    },

    pioneers: {
      en: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-en/Pioneers-Guide.pdf',
      pt: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-pt/pioneiros-guia.pdf',
      es: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-es/pioneros-guia.pdf',

    },

    problematic: {
      en: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-en/problematiccontent-guide.pdf',
      pt: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-pt/conteudos-problematicos-guia.pdf',
      es: 'http://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/admins/guides-es/contenido-problematico-guia.pdf',
    },

    video: {
      en: '',
      // en: 'http://www.youtube.com/watch?v=sXstR3AH4us',
      es: 'http://www.youtube.com/watch?v=7A2vtPa8hnY',
      pt: 'http://www.youtube.com/watch?v=85tNW2yoXC4',
    },
  },

  ux: {
    alertTimeout: 3000, //milliseconds
  },

  sentryURL: sentryURL,

  sentryOptions: sentryOptions,

   regex: {
    // determine if the last "word" start with a `@`
    ADD_NEW_MENTION: /(?:^| )@([^ \n]*)$/,
    // detect the expressions of the form @[n] with an integer
    MENTIONED_USERS_ID: /@\[([0-9]+)]/g,
    // detect emoticons
    // [8:;] - starts with any of these chars
    // ['-]{0,} - optionally has an extra char, like hyphen eg, :-D
    // (&#39;){0,1} - for smiley's with single quote, since single quote is encoded. eg, :'(
    // [dDpPoOxX|/\)\(] - followed by one of these charset: d,D,p,P,o,O,x,X,|,),(
    SMILEYS: /[8:;]['-]{0,}('){0,1}[dDpPoOxX|\/\)\(](?=$|\s)/g,
    // Found on http://daringfireball.net/2010/07/improved_regex_for_matching_urls
    /* eslint-disable */
    URL: /(?:\s|^)((?:(?:f|ht)tps?:\/\/(?:www\.)?|www\.)([-a-zA-Z0-9@:%_\+,'~#?;&\/\/=!()]+\.[-a-zA-Z0-9@:%_\+.,'~#?;&\/\/=!()]*[-a-zA-Z0-9@%_\+~'#&\/\/=(]))/g,
    YOUTUBE_URL: /(?:youtube\.com\/watch\?v=|youtu\.be\/)(.*)/,
    /* eslint-enable */
    BBCODE: /\[\/?(?:b|i|u)]/g,
    UNDESIRABLE_CHARACTERS: [
      { pattern: /\xa0/gi, replacement: ' ' },
    ],
  },

  discover: {
    communities: [
      'bhf',
      'johns',
      'mount-sinai-stroke',
      'mymsaa',
      'share-breast-cancer-support',
      'share-metastatic-support',
      'share-ovarian-cancer-support',
      'ovacome',
    ],
  },

  hideWriteCTA: [
    'latest',
    'news-updates',
    'pss-research',
    'pss-research2',
  ],

}, buildConfig);




// WEBPACK FOOTER //
// ./config/config.js